import store from '@/store'
import { useLazyQuery } from '@vue/apollo-composable';
import * as api from '@/api/okaso-api'


export type SearchLengthsCondition = {
  customerId?: number;
  itemCd?: number;
  largeCategoryCd?: number;
  middleCategoryCd?: number;
  diameters?: string[];
  smallCategories?: api.SmallCategory[];
}

export function useSearchLengthsFunc() {

  const getWhere = (condition: SearchLengthsCondition) => {
    // 得意先で絞る --------------------
    let customerId = condition.customerId
    if (!customerId) {
      // ログイン中の得意先CDで絞り込む
      customerId = store.getters['loginUser/customer']?.id
    }

    const where: api.StockItemWhereInput  = {
      AND: [
        {
          stockItemUnitPrices: {
            some: {
              customerId: {
                equals: customerId
              }
            }
          }
        },
        {
          length: {
            not: {
              equals: ""
            }
          }
        }
      ],
    }

    // 商品で絞る --------------------
    // let itemId = condition.itemId
    // if (!!itemId) {
    //   where.AND?.push({
    //     item: {
    //       is: {
    //         id: { equals: itemId }
    //       }
    //     }
    //   })
    // }
    let itemCd = condition.itemCd
    if (!!itemCd) {
      where.AND?.push({
        item: {
          is: {
            itemCd: { equals: itemCd }
          }
        }
      })
    }

    // 大分類で絞る --------------------
    // let largeCategoryId = condition.largeCategoryId
    // if (!!largeCategoryId) {
    //   where.AND?.push({
    //     item: {
    //       is: {
    //         largeCategory: {
    //           is: {
    //             id: { equals: largeCategoryId }
    //           }
    //         }
    //       }
    //     }
    //   })
    // }
    let largeCategoryCd = condition.largeCategoryCd
    if (!!largeCategoryCd) {
      where.AND?.push({
        item: {
          is: {
            largeCategory: {
              is: {
                largeCd: { equals: largeCategoryCd }
              }
            }
          }
        }
      })
    }

    // 中分類で絞る --------------------
    // let middleCategoryId = condition.middleCategoryId
    // if (!!middleCategoryId) {
    //   where.AND?.push({
    //     item: {
    //       is: {
    //         middleCategory: {
    //           is: {
    //             id: { equals: middleCategoryId }
    //           }
    //         }
    //       }
    //     }
    //   })
    // }
    let middleCategoryCd = condition.middleCategoryCd
    if (!!middleCategoryCd) {
      where.AND?.push({
        item: {
          is: {
            middleCategory: {
              is: {
                middleCd: { equals: middleCategoryCd }
              }
            }
          }
        }
      })
    }

    // 小分類で絞る --------------------
    let smallCategories = condition.smallCategories
    if (!!smallCategories && smallCategories.length > 0) {
      where.AND?.push({
        item: {
          is: {
            smallCategory: {
              is: {
                id: { in: smallCategories.map(s => s.id) }
              }
            }
          }
        }
      })
    }

    // 径で絞る --------------------
    let diameters = condition.diameters
    if (!!diameters && diameters.length > 0) {
      where.AND?.push({
        diameter: {
          in: diameters
        }
      })
    }

    return where
  }

  const {
    load: searchLengthsLoad,
    refetch: searchLengthsRefetch,
    onResult: searchLengthsOnResult,
    onError: searchLengthsOnError
  } = useLazyQuery<
    api.LengthsQuery,
    api.LengthsQueryVariables
  >(api.LengthsDocument, undefined)

  const searchLengthsFetchOrRefetch = (variables:api.LengthsQueryVariables) => {
    searchLengthsLoad(api.LengthsDocument, variables) || searchLengthsRefetch(variables)
  }

  const searchLengths = ( condition: SearchLengthsCondition ) => {
    const where = getWhere(condition)

    // 検索実行
    searchLengthsFetchOrRefetch({
      where,
      orderBy: [
        {
          lengthCd: api.SortOrder.Asc,
        },
        {
          length: api.SortOrder.Asc,
        }
      ]
    })
  }

  return {
    searchLengths,
    searchLengthsOnResult,
    searchLengthsOnError
  }
}
